import React, { useState } from 'react'
import { MessageCircleMore } from 'lucide-react'

interface Props {
    handleShowChat: () => void
}

const AISparkle = ({ size = 20 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
    >
        <path
            d="M16.2 8.00833L13.7 6.75833L11.4667 5.64167L11.4417 5.61667L10.325 3.38333L9.075 0.883333C8.79167 0.316667 7.86667 0.316667 7.58333 0.883333L6.33333 3.38333L5.21667 5.61667L5.19167 5.64167L2.95833 6.75833L0.458333 8.00833C0.175 8.15 0 8.44167 0 8.75C0 9.05833 0.175 9.35 0.458333 9.49167L2.95833 10.7417L5.19167 11.8583L5.21667 11.8833L6.33333 14.1167L7.58333 16.6167C7.725 16.9 8.01667 17.075 8.325 17.075C8.63333 17.075 8.925 16.9 9.06667 16.6167L10.3167 14.1167L11.4333 11.8833L11.4583 11.8583L13.6917 10.7417L16.1917 9.49167C16.475 9.35 16.65 9.05833 16.65 8.75C16.65 8.44167 16.475 8.15 16.1917 8.00833H16.2ZM14.575 0L13.7917 1.71667L12.075 2.5L13.7917 3.28333L14.575 5L15.3583 3.28333L17.075 2.5L15.3583 1.71667L14.575 0Z"
            fill="url(#star_gradient)"
        />
        <defs>
            <linearGradient
                id="star_gradient"
                x1="0"
                y1="0"
                x2="100%"
                y2="100%"
                gradientTransform="rotate(39.61)"
            >
                {/* Light Purple to Pale Blue Gradient */}
                <stop offset="2.34%" stopColor="#9798FC" />
                <stop offset="97.66%" stopColor="#D6D7FF" />
            </linearGradient>
        </defs>
    </svg>
);

export default function ChatButton({ handleShowChat }: Props) {
    const [isVerified, setIsVerified] = useState(() => {
        return sessionStorage.getItem('approval_status') === 'true';
    });

    return (
        <button
            onClick={handleShowChat}
            className={`${isVerified ? 'hover:cursor-pointer bg-gray-800 text-white' : 'hover:cursor-not-allowed bg-gray-200 text-gray-300'}  shadow-lg p-3 rounded-full fixed bottom-5 right-5 z-50`}
            disabled={!isVerified}
        >
            <AISparkle size={30} />
        </button>
    )
}
